import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class LoadPathReportQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(load_path_id:string): Promise<any> {
    let args = { 
      load_path_id: load_path_id,
    }
    let res = undefined;    
    res = await this.dispatcher.dispatch('load_path_report_query', args)
    if (res) {
      this.frontend.excludedFiles = res.excluded_files
      this.frontend.excludedDate = res.excluded_date
    }
  }
}